import React from "react"
import styled from "styled-components"
import ReactMarkdown from "react-markdown"
import { fontSize } from "buoy-theme"
import Text from "../../common/components/Text"
import Link from "../../common/components/Link"

export const ListItem = styled.li`
  margin-bottom: 8px;
  ${fontSize("bodyMain")};
`

export const List = styled.ul`
  margin-top: 0;
  max-width: 440px;
`

export const Paragraph = styled(Text)`
  margin-bottom: 8px;
  max-width: 440px;
`
/* link and linkReference need to be specified separately in the object because they are separate renderers for separate components.
 * link: is any <a> tag that is not a linkReference.
 * linkReference: in markdown refers to the following sintax [text][reference/link], in which the reference link is set at the bottom of the text.
 * See the link section, under reference-style link on https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet for more information on linkReference.
 */
const renderers = {
  paragraph: Paragraph,
  listItem: ListItem,
  list: List,
  link: props => (
    <Link size="bodyMain" {...props} target="_blank" rel="noopener" />
  ),
  linkReference: props => (
    <Link size="bodyMain" {...props} target="_blank" rel="noopener" />
  ),
}

const MarkdownSection = ({ source }) => (
  <ReactMarkdown source={source} renderers={renderers} />
)

export default MarkdownSection



// WEBPACK FOOTER //
// ./assets/completion/components/MarkdownSection.js